:host {
  display: block;
}
.form-btn-submit{
  display: flex;
  height: 55px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--mainColor);
  color: white;
  font-weight: bold;
  border-radius: var(--mainRadius);
  border: none;
  cursor: pointer;
}
.form-container{
  display: flex;
  flex-direction: column;
  gap:20px;
  padding: 44px;
   border: 1px solid var(--mainColor); 
 min-height: 400px;

   border-radius: 8px;
  position: relative;
}
.form-loading-container{
 display: flex;
 align-items: center;
 justify-content: center;
 position: absolute;
 top: 0px;
 left: 0px;
 width: 100%;
 z-index: 99;
 height: 100%;
 background-color: #F1F1F1; ;
 
}
.form-loading{
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--mainColor);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  z-index: 99;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
